import { register } from '@antv/x6-vue-shape'
import { Graph, Edge, Shape } from '@antv/x6'
import { Selection } from '@antv/x6-plugin-selection'
import { Snapline } from '@antv/x6-plugin-snapline'
// import { Scroller } from '@antv/x6-plugin-scroller'
import { Keyboard } from '@antv/x6-plugin-keyboard'
import { History } from '@antv/x6-plugin-history'
import FlowCmp from '@/components/FlowChart/flowCmp.vue'
import FlowApproval from '@/components/FlowChart/flowApproval.vue'
import NodeDialog from '@/components/FlowChart/nodeDialog.vue'
import FlowResult from '@/components/FlowChart/flowResult.vue'
import FlowStart from '@/components/FlowChart/flowStart.vue'
import FlowBusinessResult from '@/components/FlowChart/flowBusinessResult.vue'
// 注册插件or组件
export function createGraphPlugin(graph: Graph | undefined, options: any): void {
  register({
    shape: 'flow-comp',
    width: 180,
    height: 38,
    component: FlowCmp,
    ports: {
      groups: {
        top: {
          position: 'top',
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent',
              class: 'haha-cussss'
            }
          }
        },
        bottom: {
          position: {
            name: 'bottom'
          },
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent'
            }
          }
        },
        left: {
          position: {
            name: 'left'
          },
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent'
            }
          }
        },
        right: {
          position: {
            name: 'right'
          },
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent'
            }
          }
        }
      }
    }
  })
  register({
    shape: 'flow-approval-comp',
    width: 180,
    height: 88,
    component: FlowApproval,
    ports: {
      groups: {
        top: {
          position: 'top',
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent',
              class: 'haha-cussss'
            }
          }
        },
        bottom: {
          position: {
            name: 'bottom'
          },

          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent'
            }
          }
        },
        left: {
          position: {
            name: 'left'
          },
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent'
            }
          }
        },
        right: {
          position: {
            name: 'right'
          },
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'transparent',
              strokeWidth: 1,
              fill: 'transparent'
            }
          }
        }
      }
    }
  })
  register({
    shape: 'flow-dialog',
    width: 400,
    height: 200,
    component: NodeDialog
  })
  register({
    shape: 'flow-result',
    width: 180,
    height: 66,
    component: FlowResult
  })
  register({
    shape: 'flow-business-result',
    width: 180,
    height: 66,
    component: FlowBusinessResult
  })
  register({
    shape: 'flow-start',
    width: 136,
    height: 62,
    component: FlowStart
  })
  Edge.config({
    markup: [
      {
        tagName: 'path',
        selector: 'wrap',
        attrs: {
          fill: 'none',
          cursor: 'pointer',
          stroke: 'transparent',
          strokeLinecap: 'round'
        }
      },
      {
        tagName: 'path',
        selector: 'line',
        attrs: {
          fill: 'none',
          pointerEvents: 'none'
        }
      }
    ],
    attrs: {
      wrap: {
        connection: true,
        strokeWidth: 10,
        strokeLinejoin: 'round'
      },
      line: {
        connection: true,
        stroke: '#aaaaaa',
        strokeWidth: 1,
        targetMarker: {
          name: 'classic',
          size: 6
        }
      },
      labels: {
        attrs: {
          fill: 'none'
        }
      }
    },
    data: {
      name: '',
      order: 0,
      def: false
    }
  })
  Shape.Rect.config({
    size: {
      width: 88,
      height: 38
    },
    attrs: {
      body: {
        stroke: '#fff',
        strokeWidth: 1,
        fill: '#fff',
        rc: 20,
        ry: 20
      },
      text: {
        fill: '#4470DB'
      }
    },
    ports: {
      groups: {
        top: {
          position: 'top',
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'red',
              strokeWidth: 1,
              fill: 'red',
              class: 'start-port'
            }
          }
        },
        bottom: {
          position: {
            name: 'bottom'
          },

          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'red',
              strokeWidth: 1,
              fill: 'red',
              class: 'start-port'
            }
          }
        },
        left: {
          position: {
            name: 'left'
          },
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'red',
              strokeWidth: 1,
              fill: 'red',
              class: 'start-port'
            }
          }
        },
        right: {
          position: {
            name: 'right'
          },
          attrs: {
            circle: {
              r: 4,
              magnet: true,
              stroke: 'red',
              strokeWidth: 1,
              fill: 'red',
              class: 'start-port'
            }
          }
        }
      }
    }
  })
  Graph.registerEdge('customer-edge', Edge, true)

  options.selection &&
    graph!.use(
      new Selection({
        multiple: true,
        rubberEdge: true,
        multipleSelectionModifiers: ['ctrl', 'shift'],
        rubberNode: true,
        rubberband: true
      })
    )
  graph!.use(
    new Snapline({
      enabled: true
    })
  )
  graph!.use(
    new Keyboard({
      enabled: true
    })
  )
  graph!.use(
    new History({
      enabled: true,
      ignoreChange: false,
      beforeAddCommand: (e, { key }: any) => {
        return key !== 'ports' && key !== 'attrs'
      }
    })
  )
  // graph!.use(
  //   new Scroller({
  //     enabled: true
  //   })
  // )
}
